export const FETCH_TIME2CHAT_NUMBERS = 'FETCH_TIME2CHAT_NUMBERS';
export const CREATE_TIME2CHAT_NUMBER = 'CREATE_TIME2CHAT_NUMBER';
export const UPDATE_TIME2CHAT_NUMBER = 'UPDATE_TIME2CHAT_NUMBER';
export const ASSIGN_TIME2CHAT_NUMBER = 'ASSIGN_TIME2CHAT_NUMBER';
export const REASSIGN_TIME2CHAT_NUMBER = 'REASSIGN_TIME2CHAT_NUMBER';
export const REMOVE_TIME2CHAT_NUMBER = 'REMOVE_TIME2CHAT_NUMBER';
